export const NOTIFICATION_AUTO_CLOSE_DURATION = 3000;

export const PageSize = 10;

enum PortalLanguages {
  EN = 'en',
  IT = 'it',
}

export const DEFAULT_PORTAL_LANGUAGES = [
  PortalLanguages.EN,
  PortalLanguages.IT,
];
export const DEFAULT_PORTAL_LANGUAGE = PortalLanguages.IT;

export const BOLOGNA_ENV_URL = [
  'https://bolognafc.emp.hidcloud.com'
];
export const BOLOGNA_LOGO_URL =
  'https://production-tmt.s3.eu-west-1.amazonaws.com/931/bolognaform/Bologna-logo_1724260815672.png';
